import script from "./base-allowedaction-overflow.vue?vue&type=script&lang=ts"
export * from "./base-allowedaction-overflow.vue?vue&type=script&lang=ts"

import "./base-allowedaction-overflow.vue?vue&type=style&index=0&id=35859528&lang=css"

const __exports__ = script;

export default __exports__